import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {
  MatSlideToggle,
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';
import { CampusService } from '../../../services/campus.service';
import { Campus } from '../../../models/campus.model';
import { EduEmailValidator } from '../../../validators/edu-email.validator';
import { states } from '../../../constants';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-edit-campus-dialog',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    CommonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatProgressBarModule,
    FormsModule,
    MatSlideToggleModule,
    MatSelectModule,
  ],
  templateUrl: './edit-campus-dialog.component.html',
  styleUrl: './edit-campus-dialog.component.scss',
})
export class EditCampusDialogComponent implements OnInit {
  loading: boolean = false;
  states = states;
  statusChecked: boolean = false;
  mainCampusChecked: boolean = false;

  editCampusForm = new FormGroup({
    id: new FormControl(''),
    collegeId: new FormControl(''),
    name: new FormControl('', Validators.required),
    emailDomain: new FormControl('', [Validators.required, EduEmailValidator]),
    status: new FormControl('ACTIVE'),
    street: new FormControl('', Validators.required),
    city: new FormControl('', Validators.required),
    state: new FormControl('', Validators.required),
    zipcode: new FormControl('', Validators.required),
    isMainCampus: new FormControl(false, Validators.required),
  });

  constructor(
    private campusService: CampusService,
    private dialogRef: MatDialogRef<EditCampusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { campusToEdit: Campus }
  ) {}
  ngOnInit(): void {
    this.editCampusForm.controls.id.setValue(this.data.campusToEdit.id);
    this.editCampusForm.controls.collegeId.setValue(
      this.data.campusToEdit.collegeId
    );

    this.editCampusForm.controls.name.setValue(this.data.campusToEdit.name);

    this.editCampusForm.controls.emailDomain.setValue(
      this.data.campusToEdit.emailDomain
    );

    this.editCampusForm.controls.status.setValue(this.data.campusToEdit.status);

    this.editCampusForm.controls.street.setValue(this.data.campusToEdit.street);

    this.editCampusForm.controls.city.setValue(this.data.campusToEdit.city);

    this.editCampusForm.controls.state.setValue(this.data.campusToEdit.state);

    this.editCampusForm.controls.zipcode.setValue(
      this.data.campusToEdit.zipCode
    );

    this.editCampusForm.controls.isMainCampus.setValue(
      this.data.campusToEdit.isMainCampus
    );

    this.statusChecked =
      this.editCampusForm.controls.status.value == 'ACTIVE' ? true : false;

    this.mainCampusChecked = this.data.campusToEdit.isMainCampus;
  }

  onSubmit() {
    this.statusChecked
      ? this.editCampusForm.controls.status.setValue('ACTIVE')
      : this.editCampusForm.controls.status.setValue('INACTIVE');

    this.editCampusForm.controls.isMainCampus.setValue(this.mainCampusChecked);
    const campus: Campus = this.editCampusForm.value as Campus;

    this.campusService.update(campus).subscribe({
      next: () => {
        this.loading = false;
        this.dialogRef.close({
          message: 'Campus saved suceessfully!',
        });
      },
      error: () => {
        this.loading = false;
        this.dialogRef.close({
          message: 'Campus could not be saved successfully. Please try again.',
        });
      },
    });
  }

  onCancel() {
    this.dialogRef.close();
  }
}
